import { render } from "./EntriesFilterBar.vue?vue&type=template&id=b871f0f6&scoped=true"
import script from "./EntriesFilterBar.vue?vue&type=script&lang=js"
export * from "./EntriesFilterBar.vue?vue&type=script&lang=js"

import "./EntriesFilterBar.vue?vue&type=style&index=0&id=b871f0f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b871f0f6"]])

export default __exports__